import {VIDEO_PROVIDERS} from '@adv-mt/ui/media-video'

// Scrolls an element to the top of the viewport. Users who asked their OS for less animation get an
// instant jump instead of a smooth one.
export const scrollToElement = element => {
  if (!element) return

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  element.scrollIntoView({behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start'})
}

// Same, for one of the page sections listed in `AD_DETAIL_PAGE_SECTION_IDS`. Does nothing when the
// section is not on the page, since panels render conditionally.
export const scrollToSection = sectionId => scrollToElement(document.getElementById(sectionId))

export const getContactOfferTypeFlags = ({adType = {}, searchConfig}) => {
  const {DEFAULT_CATEGORY1_ID, OFFER_TYPE_KM0, OFFER_TYPE_NEW, OFFER_TYPE_SECOND_HAND} = searchConfig

  return {
    isNewVehicle: adType.offerTypeId === OFFER_TYPE_NEW,
    isVOorVNorKM0:
      [OFFER_TYPE_SECOND_HAND, OFFER_TYPE_KM0, OFFER_TYPE_NEW].includes(adType.offerTypeId) &&
      adType.category1Id === DEFAULT_CATEGORY1_ID
  }
}

const detectVideoProvider = url => {
  if (url.includes('yams')) return VIDEO_PROVIDERS.HLS
  if (url.includes('youtube.com') || url.includes('youtu.be')) return VIDEO_PROVIDERS.YOUTUBE
  if (url.includes('vimeo.com')) return VIDEO_PROVIDERS.VIMEO
  return VIDEO_PROVIDERS.NATIVE
}

export const computeGalleryVideo = ({ad, isCoches}) => {
  const rawVideo = ad?.videos?.[0]
  if (!isCoches || !rawVideo?.url) return undefined

  return {
    url: rawVideo.url,
    provider: detectVideoProvider(rawVideo.url),
    position: rawVideo.position,
    autoPlay: rawVideo.autoPlay,
    poster: ad?.photos?.[0] ?? null
  }
}
